export default __webpack_public_path__ + "static/media/addListButton.3c0d8bb1.svg";